import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { educationInitialState, EducationOption } from "./initialState";

const educationSlice = createSlice({
    name: "education",
    initialState: () => {
        const initialState = { ...educationInitialState };
        return initialState;
      },
    
    reducers: {
      setEducationOptions(state, action: PayloadAction<EducationOption[]>) {
        state.selectedEducationOptions = action.payload;
      },
    },
  });
  
  export const { setEducationOptions } = educationSlice.actions;
  
  export default educationSlice;
